import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, Subject } from "rxjs";

import { environment as ENV } from "environments/environment";
import { PageContratistaDTO } from "../../interfaces/page-contratista.interface";
import { ContratistaDTO } from "../../models/contratista.model";
import { map } from "rxjs/operators";
import { RegionComunaDTO } from "../../interfaces/region-comuna.interface";
import { CodigoDTO } from "../../interfaces/codigo.interface";
import { Comuna } from "../../interfaces/comuna.interface";
import { FiltrosService } from "../util/filtros.service";
import { GrupoServicioSolicitadoDTO } from "../../interfaces/grupo-servicio-solicitado.interface";

const API = "contratistas/";

@Injectable({
    providedIn: "root",
})
export class ContratistaService {
    contratistasChanged$: Subject<PageContratistaDTO>;
    contratistaChanged$: Subject<ContratistaDTO>;
    contratistasRefresh$: BehaviorSubject<boolean>;
    especialidadesChanged$: BehaviorSubject<boolean>;

    private paginaActual: number;
    private cantidaResultadosPorPagina: number;
    private totalDeResultados: number;
    private cantidadPaginas: number;

    private orden: string;
    private campoOrden: string;
    constructor(private http: HttpClient, private _filtros: FiltrosService) {
        this.contratistasChanged$ = new Subject();
        this.contratistaChanged$ = new Subject();
        this.contratistasRefresh$ = new BehaviorSubject(null);
        this.especialidadesChanged$ = new BehaviorSubject(null);

        this.resetPaginador();
    }

    setCampoOrden(campoOrden: string) {
        this.campoOrden = campoOrden;
    }

    getCampoOrden(): string {
        return this.campoOrden;
    }

    setCantidadPaginas(cantidadPaginas: number): void {
        this.cantidadPaginas = cantidadPaginas;
    }

    getCantidadPaginas(): number {
        return this.cantidadPaginas;
    }

    getTotalDeResultados(): number {
        return this.totalDeResultados;
    }

    setTotalDeResultados(totalDeResultados: number): void {
        this.totalDeResultados = totalDeResultados;
    }

    setOrden(orden: string): void {
        this.orden = orden;
    }

    getOrden(): string {
        return this.orden;
    }

    setPaginaActual(pagina: number): void {
        this.paginaActual = pagina;
    }

    getPaginaActual(): number {
        return this.paginaActual;
    }

    setCantidaResultadosPorPagina(cantidadResultados: number): void {
        this.cantidaResultadosPorPagina = cantidadResultados;
    }

    getCantidaResultadosPorPagina(): number {
        return this.cantidaResultadosPorPagina;
    }

    resetPaginador() {
        this.paginaActual = 0;
        this.cantidaResultadosPorPagina = 10;
        this.totalDeResultados = 0;
        this.cantidadPaginas = 0;
        this.campoOrden = "p.nombres";
        this.orden = "asc";
    }

    fetchContratistas(
        activos?: boolean,
        idGrupoServicio?: number,
        idComuna?: number,
        evaluacionMinima?: number,
        nombre?: string,
        rut?: number
    ): Observable<PageContratistaDTO> {
        const filtrosContratista =
            this._filtros.getFiltro("filtrosContratista");
        //console.log(filtrosContratista);
        return this.http
            .get<PageContratistaDTO>(
                `${ENV.apiUrl}${API}?activos=${
                    activos || filtrosContratista.estado[0].valor
                }&nombre=${nombre || filtrosContratista.nombre[0].valor}&rut=${
                    rut || filtrosContratista.rut[0].valor
                }&grupo=${
                    idGrupoServicio || filtrosContratista.grupo[0].valor
                }&comuna=${
                    idComuna || filtrosContratista.comuna[0].valor
                }&evaluacion=${
                    evaluacionMinima || filtrosContratista.evaluacion[0].valor
                }&page=${this.paginaActual}&size=${
                    this.cantidaResultadosPorPagina
                }&sort=${this.campoOrden},${this.orden}`
            )
            .pipe(
                map((contratistas) => {
                    contratistas.content.forEach(
                        (contratista) =>
                            (contratista.evaluacion = parseFloat(
                                contratista.evaluacion.toFixed(1)
                            ))
                    );
                    return contratistas;
                })
            );
    }

    eliminarContratista(rut: number): Observable<any> {
        return this.http.delete<any>(`${ENV.apiUrl}${API}${rut}`);
    }

    fetchContratista(rutContratista: number): Observable<ContratistaDTO> {
        return this.http
            .get<ContratistaDTO>(`${ENV.apiUrl}${API}${rutContratista}`)
            .pipe(
                map((contratista) => {
                    contratista.evaluacion = parseFloat(
                        contratista.evaluacion.toFixed(1)
                    );

                    return contratista;
                })
            );
    }

    actualizaContratista(contratista: ContratistaDTO): Observable<any> {
        return this.http.put<any>(`${ENV.apiUrl}${API}`, contratista);
    }

    actualizaGrupos(rutContratista: number, grupos: number[]) {
        return this.http.patch<any>(
            `${ENV.apiUrl}${API}${rutContratista}/grupos`,
            grupos
        );
    }
    actualizaComunas(rutContratista: number, comunas: number[]) {
        return this.http.patch<any>(
            `${ENV.apiUrl}${API}${rutContratista}/comunas`,
            comunas
        );
    }

    fetchGrupoServicioSolicitado(
        rutContratista: number
    ): Observable<GrupoServicioSolicitadoDTO[]> {
        return this.http.get<GrupoServicioSolicitadoDTO[]>(
            `${ENV.apiUrl}${API}${rutContratista}/solicitudes/`
        );
    }
}
